export const TICKETING_WHO_RESPONDS_PANEL_ID = 'Ticketing_Who_Responds_Panel_ID';
export const TICKETING_WHO_RESPONDS_LIST_ID = 'TicketingWhoRespondsListID';
